/**
 * Constants for the User Directory feature
 */

// Maximum number of characters to display in the profile about snippet
export const MAX_PROFILE_ABOUT_SNIPPET_LENGTH = 80;

// Default number of users to fetch per API call
export const USER_DIRECTORY_PAGE_SIZE = 15;

// Alphabet letters for the directory navigation
export const ALPHABET_LETTERS = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
];

// Debounce delay for scroll events (in milliseconds)
export const SCROLL_DEBOUNCE_DELAY = 300;

// Number of letters to load at a time in the directory
export const LETTER_LOAD_BATCH_SIZE = 4;
